module.exports = __webpack_public_path__ + "static/media/IMG_0698.79940d47.JPG";